import React, { Component } from 'react'
import { Provider } from 'unstated'
import styled, { injectGlobal } from 'styled-components'
import Menu from '../components/Menu'
import MenuToggle from '../components/MenuToggle'
import LanguageSwitcher from '../components/LanguageSwitcher'
import { colors, rhythm, media } from '../utils/style-utils'
import Footer from '../components/Footer'
import Disclaimer from '../components/Disclaimer'
import '../fonts/butler/butler_medium.css'

/* eslint no-unused-expressions: off */
injectGlobal`
@import url('https://use.typekit.net/bnx4xdg.css');

*, *::after, *::before {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  overflow-x: hidden;
  max-width: 100%;
  font-size: 13px;
  ${media.tablet`
    font-size: 14px;
  `}
  ${media.desktop`
    font-size: 15px;
  `}
}

body {
  font-family: 'proxima-nova', sans-serif;
  line-height: 1.5;
  color: ${colors.black};
  width: 100%;
}

.l-constrained {
  max-width: 1200px;
  width: 90%;
  margin: 0 auto;
}

.c-body {
  > * + * {
    margin-top: ${rhythm(1)};
  }

  li + li {
    margin-top: ${rhythm(1)};    
  }
}
`

const Container = styled.div`
  position: relative;
`

const StripesContainer = styled.div``
const Stripe = styled.div`
  position: absolute;
  top: 0;
  height: 100%;
  z-index: -1;
  border-left: 1px solid ${colors.mercuryLight};
  &:nth-child(1) {
    left: 25%;
  }
  &:nth-child(2) {
    left: 50%;
  }
  &:nth-child(3) {
    left: 75%;
  }
`
class DefaultLayout extends Component {
  state = {
    menuOpen: false,
  }

  setMenuOpen = () => {
    this.setState({ menuOpen: true })
  }

  setMenuClosed = () => {
    this.setState({ menuOpen: false })
  }

  render() {
    const { children, data } = this.props
    const sitename = data.site.siteMetadata.title
    return (
      <Provider>
        <Container>
          <MenuToggle onClick={this.setMenuOpen} />
          <LanguageSwitcher />
          <Menu
            menuLabels={data.menu_labels.strings}
            isOpen={this.state.menuOpen}
            onCloseClick={this.setMenuClosed}
          />
          <StripesContainer>
            <Stripe />
            <Stripe />
            <Stripe />
          </StripesContainer>
          {children()}
          <Footer sitename={sitename} />
          <Disclaimer data={data.disclaimer} />
        </Container>
      </Provider>
    )
  }
}

export default DefaultLayout



// WEBPACK FOOTER //
// ./src/components/DefaultLayout.js